import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import Button from "../../../../modules/commons/Button";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import moment from "moment";

class ReceivingPartDGISearch extends Component {
  // Ambil value dari state, jika null/undefined pakai hari ini
  // Selalu format output DD-MM-YYYY untuk tampil di input
  getDataValue(fieldName) {
    const today = moment().format("DD-MM-YYYY");

    if (!this.props.state.searchData) return today;

    const value = this.props.state.searchData[fieldName];
    if (!value) return today;

    // Jika value sudah dalam DD-MM-YYYY, langsung kembalikan
    if (moment(value, "DD-MM-YYYY", true).isValid()) return value;

    // Jika value format YYYY-MM-DD, konversi ke DD-MM-YYYY
    return moment(value).format("DD-MM-YYYY");
  }

  render() {
    return (
      <FlexView
        style={{ justifyContent: "space-between" }}
        vAlignContent="center"
        className="margin-top-5px"
      >
        <form onSubmit={this.props.onSubmit}>
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama cabang hak akses"
              options={this.props.state.cabangOptions}
              value={this.props.state.kodeCabang}
              onChange={(value, { name }) =>
                this.props.onCabangChange(name, value)
              }
            />
            <p className="margin-left-25px margin-bottom-20px">Periode</p>
            <SimpleDate
              id="select_date_startDate"
              name="startDate"
              // nextdate
              date={this.getDataValue("startDate")}
              // maxDate={this.getDataValue("endDate")}
              onChange={(value) => this.props.onValueChange("startDate", value)}
            />
            <SimpleDate
              id="select_date_endDate"
              name="endDate"
              backdate
              date={this.getDataValue("endDate")}
              minDate={this.getDataValue("startDate")}
              onChange={(value) => this.props.onValueChange("endDate", value)}
            />
            <SimpleButton type="submit" className="margin-bottom-20px">
              Cari
            </SimpleButton>
          </FlexView>
        </form>
        <Button
          type="button"
          onClick={this.props.onShowFilter}
          className="btn background-red margin-bottom-20px"
        >
          <span>
            <i className="fa fa-qrcode"></i>
          </span>
        </Button>
      </FlexView>
    );
  }
}

export default ReceivingPartDGISearch;
